/* svelte-refresh.js — default 2x tier + reviews carousel + benefits rotator + size-guide link */
(function(){
  function default2x(){
    var tries = 0;
    var iv = setInterval(function(){
      tries++;
      var tile = document.querySelector('.svelte-bundle-tile[data-qty="2"]');
      if (!tile) { if (tries > 12) clearInterval(iv); return; }
      if (tile.getAttribute('data-active') === 'true') { clearInterval(iv); return; }
      tile.click();
      if (tries > 15) clearInterval(iv);
    }, 150);
  }

  function sizeGuideLink(){
    var link = document.querySelector('.svelte-bundle-strip-link, [data-svelte-bundle-strip-link]');
    var modal = document.querySelector('.svelte-size-modal');
    if (!link || !modal) return;
    var body = modal.querySelector('.svelte-size-modal-body');
    function outside(sel){
      return [].slice.call(document.querySelectorAll(sel)).filter(function(n){ return !modal.contains(n); });
    }
    link.textContent = 'Size & Fit Guide';
    link.setAttribute('href', '#');
    link.addEventListener('click', function(e){
      e.preventDefault();
      if (body && body.innerHTML.replace(/\s/g, '').length < 10){
        var tip  = outside('.svelte-sizing-tip')[0];
        var wrap = outside('.svelte-size-table-wrap')[0];
        var note = outside('.svelte-stat-disclaimer, .svelte-size-note')[0];
        if (tip)  body.appendChild(tip.cloneNode(true));
        if (wrap) body.appendChild(wrap.cloneNode(true));
        if (note) body.appendChild(note.cloneNode(true));
      }
      try { if (typeof modal.showModal === 'function') modal.showModal(); else modal.setAttribute('open',''); }
      catch (err) { modal.setAttribute('open',''); }
    });
  }

  var R = [
    {i:'PK', n:'Priya K.',    b:'Wore it to a wedding and danced all night — zero rolling, zero readjusting. Total game changer.'},
    {i:'DR', n:'Danielle R.', b:'I am self-conscious about my tummy and this smooths everything so nicely under dresses.'},
    {i:'SG', n:'Sofia G.',    b:'The butt-lifting seam is no joke — my jeans fit better instantly. Obsessed.'},
    {i:'TB', n:'Tanya B.',    b:'Finally shapewear I can wear to work all day without wanting to rip it off by 2pm.'},
    {i:'AW', n:'Amara W.',    b:'Sized up like the guide said and the fit is perfect. Comfy enough to forget I have it on.'},
    {i:'ND', n:'Nicole D.',   b:'No muffin top, no lines, no rolling. It just disappears under everything.'},
    {i:'RM', n:'Rachel M.',   b:'Breathable is the word — most shapers make me sweat but this one feels light.', s:4},
    {i:'BT', n:'Bianca T.',   b:'Bought the 2-pack so I always have a clean one. Best closet purchase this year.'},
    {i:'HP', n:'Hannah P.',   b:'Snatched my waist for my birthday dress and I felt amazing all night. Highly recommend.'},
    {i:'OS', n:'Olivia S.',   b:'Took a couple wears to find my size but now it is the only shaper I reach for.', s:4}
  ];

  function card(r){
    var c = document.createElement('div');
    c.className = 'svelte-review-card';
    var stars = (r.s === 4) ? '★★★★<span style="color:#D8C6B6">★</span>' : '★★★★★';
    c.innerHTML =
      '<div class="svelte-stars">' + stars + '</div>' +
      '<p class="svelte-review-body">“' + r.b + '”</p>' +
      '<div class="svelte-review-foot"><span class="svelte-review-avatar">' + r.i + '</span>' +
      '<div><div class="svelte-review-name">' + r.n + '</div>' +
      '<div class="svelte-review-verified">✓ Verified Buyer</div></div></div>';
    return c;
  }

  function loop(mask, track){
    var speed = 0.5, setW = 0, pos = 0, paused = false, down = false, sx = 0, sl = 0;
    function measure(){ var w = track.scrollWidth / 3; if (w > 10) setW = w; }
    function norm(){ if (setW){ if (pos >= setW * 2) pos -= setW; if (pos < setW) pos += setW; } }
    measure(); if (setW){ pos = setW; mask.scrollLeft = setW; }
    function frame(){
      if (!setW){ measure(); if (setW){ pos = setW; mask.scrollLeft = setW; } requestAnimationFrame(frame); return; }
      if (paused){ pos = mask.scrollLeft; }
      else { pos += speed; norm(); mask.scrollLeft = pos; }
      requestAnimationFrame(frame);
    }
    requestAnimationFrame(frame);
    window.addEventListener('resize', function(){ setW = 0; });
    mask.addEventListener('mouseenter', function(){ paused = true; });
    mask.addEventListener('mouseleave', function(){ if (!down){ pos = mask.scrollLeft; norm(); paused = false; } });
    mask.addEventListener('mousedown', function(e){ down = true; paused = true; sx = e.pageX; sl = mask.scrollLeft; e.preventDefault(); });
    window.addEventListener('mousemove', function(e){ if (!down) return; mask.scrollLeft = sl - (e.pageX - sx); });
    window.addEventListener('mouseup', function(){ if (down){ down = false; pos = mask.scrollLeft; norm(); } });
  }

  function autoSwipe(mask, track, count){
    var i = 0, paused = false, rt = null;
    function targetFor(n){
      var el = track.children[n];
      if (!el) return mask.scrollLeft;
      var er = el.getBoundingClientRect(), mr = mask.getBoundingClientRect();
      return mask.scrollLeft + (er.left - mr.left) - (mr.width - er.width) / 2;
    }
    function step(){
      if (paused) return;
      i++;
      if (i >= count){
        mask.scrollTo({ left: targetFor(count), behavior: 'smooth' });
        setTimeout(function(){ mask.scrollTo({ left: targetFor(0), behavior: 'auto' }); i = 0; }, 700);
      } else {
        mask.scrollTo({ left: targetFor(i), behavior: 'smooth' });
      }
    }
    setInterval(step, 3200);
    mask.addEventListener('touchstart', function(){ paused = true; if (rt) clearTimeout(rt); }, {passive:true});
    mask.addEventListener('touchend', function(){
      if (rt) clearTimeout(rt);
      rt = setTimeout(function(){
        var mr = mask.getBoundingClientRect(), center = mr.left + mr.width / 2, best = 0, bd = Infinity;
        for (var k = 0; k < track.children.length; k++){
          var r = track.children[k].getBoundingClientRect(), c = r.left + r.width / 2, d = Math.abs(c - center);
          if (d < bd){ bd = d; best = k; }
        }
        i = best % count; paused = false;
      }, 3500);
    }, {passive:true});
  }

  function makeReviewCarousel(grid){
    if (grid.dataset.svrev) return;
    grid.dataset.svrev = '1';
    var base = [].slice.call(grid.children);
    R.forEach(function(r){ base.push(card(r)); });
    var isMobile = window.matchMedia && window.matchMedia('(max-width: 749px)').matches;
    var copies = isMobile ? 2 : 3;
    var track = document.createElement('div');
    track.className = 'svelte-rev-track';
    for (var cp = 0; cp < copies; cp++){
      base.forEach(function(el){ track.appendChild(cp === 0 ? el : el.cloneNode(true)); });
    }
    grid.appendChild(track);
    grid.classList.add('svelte-rev-mask');
    if (isMobile){ grid.classList.add('svelte-rev-snap'); autoSwipe(grid, track, base.length); }
    else { loop(grid, track); }
  }

  function rotator(grid){
    if (grid.dataset.svrot) return;
    var cards = [].slice.call(grid.children).filter(function(c){ return c.classList.contains('svelte-benefit-card'); });
    if (cards.length < 2) return;
    grid.dataset.svrot = '1';
    grid.classList.add('svelte-rotator');
    var dots = document.createElement('div');
    dots.className = 'svelte-rot-dots';
    cards.forEach(function(_, i){
      var d = document.createElement('span');
      d.className = 'svelte-rot-dot' + (i === 0 ? ' is-on' : '');
      dots.appendChild(d);
    });
    if (grid.parentNode) grid.parentNode.insertBefore(dots, grid.nextSibling);
    var dotEls = [].slice.call(dots.children);
    var idx = 0;
    cards[0].classList.add('is-active');
    setInterval(function(){
      cards[idx].classList.remove('is-active'); if (dotEls[idx]) dotEls[idx].classList.remove('is-on');
      idx = (idx + 1) % cards.length;
      cards[idx].classList.add('is-active'); if (dotEls[idx]) dotEls[idx].classList.add('is-on');
    }, 2000);
  }

  function init(){
    default2x();
    sizeGuideLink();
    document.querySelectorAll('.svelte-reviews-grid').forEach(function(g){
      if (g.closest('.svelte-home')) return;
      makeReviewCarousel(g);
    });
    if (window.matchMedia && window.matchMedia('(max-width: 749px)').matches){
      document.querySelectorAll('.svelte-benefits-grid').forEach(function(g){ rotator(g); });
    }
  }
  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();